import { WELLNESS_GOALS } from "@/utils/constants";

export function WellnessGoalSection({ symptomQuery, matchedDomains, onGoalSelect, onClear }) {
  return (
    <div className="bg-white py-12 px-4 border-t border-gray-200" data-testid="wellness-goal-section">
      <div className="max-w-5xl mx-auto text-center">
        <div className="text-brand-red text-xs font-body font-bold uppercase tracking-widest mb-3">Your Wellness Journey</div>
        <h2 className="font-heading text-3xl sm:text-4xl text-navy font-bold mb-3">Find Venues by Wellness Goal</h2>
        <p className="font-body text-gray-500 text-base mb-8 max-w-2xl mx-auto">Select a goal below to discover wellness goal rated venues aligned with your priorities.</p>
        <div className="flex flex-wrap justify-center gap-2">
          {Object.keys(WELLNESS_GOALS).map((goal) => (
            <button
              key={goal}
              onClick={() => onGoalSelect(goal, WELLNESS_GOALS[goal])}
              className={`px-4 py-2 rounded-full font-body text-sm border transition-all ${
                symptomQuery === goal
                  ? "bg-brand-red text-white border-brand-red"
                  : "bg-white text-gray-600 border-gray-200 hover:border-brand-red hover:text-brand-red"
              }`}
              data-testid={`goal-${goal.toLowerCase().replace(/ /g, "-")}`}
            >
              {goal}
            </button>
          ))}
        </div>
        {symptomQuery && matchedDomains.length > 0 && (
          <div className="mt-4 flex items-center justify-center gap-2 flex-wrap">
            <span className="font-body text-xs text-gray-500">Matching domains:</span>
            {matchedDomains.map((d) => <span key={d} className="bg-brand-red/10 text-brand-red text-xs font-body px-2 py-0.5 rounded-full">{d}</span>)}
            <button onClick={onClear} className="text-gray-500 hover:text-navy text-xs font-body underline ml-2">Clear</button>
          </div>
        )}
      </div>
    </div>
  );
}
